/**
 * Store Details
 */
import storeDetailsPage from '../lib/store-details-page';
import storeDetailsEvents from '../lib/store-details-events';
import storeDetailsNearby from '../lib/store-details-nearby';

storeDetailsPage();

storeDetailsEvents();

storeDetailsNearby();
